import { render, staticRenderFns } from "./TotalEvent.vue?vue&type=template&id=40f2c4d2&"
import script from "./TotalEvent.vue?vue&type=script&lang=js&"
export * from "./TotalEvent.vue?vue&type=script&lang=js&"
import style0 from "./TotalEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports